import { Alert, Button, Text } from "@mantine/core";
import { ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useMaybePosthog } from "../hooks/useMaybePosthog";
import { getLastTraceId } from "../utils/posthogCorrelation";
import { IconAlertCircle, IconReload } from "@tabler/icons-react";

export function FlareErrorBoundary({
  title = "An error occurred",
  message = "Something went wrong",
  retryMessage = "Retry",
  children,
}: {
  title?: string;
  message?: string;
  retryMessage?: string;
  children: ReactNode;
}) {
  const posthog = useMaybePosthog();
  return (
    <ErrorBoundary
      fallbackRender={({ resetErrorBoundary }) => {
        return (
          <Alert
            title={title}
            color="red"
            style={{ cursor: "default" }}
            icon={<IconAlertCircle size={20} />}
          >
            <Text>{message}</Text>
            <br />
            <Button
              mt="sm"
              color="gray"
              variant="light"
              onClick={resetErrorBoundary}
              leftSection={<IconReload size={16} />}
            >
              {retryMessage}
            </Button>
          </Alert>
        );
      }}
      onError={(error, info) => {
        console.error(error, info);
        const traceId = getLastTraceId();
        posthog?.captureException(error, {
          info,
          ...(traceId ? { trace_id: traceId } : {}),
        });
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
